// (C) Copyright 2020 MediaWink, LLC

// https://material-ui.com/components/menus/

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Menu,
  MenuItem,
  ListItemText,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { MenuIcon } from '../constants';
import {
  selectMenuListItemsArray,
} from '../selectors';
import {
  triggerSetPublicBreadcrumbsSaga,
  triggerSetPrivateBreadcrumbsSaga,
  triggerSetAndSaveVariableSaga,
} from '../actions/items';

function AppMenu(props) {
  const { goTo } = props;
  const dispatch = useDispatch();
  const setAndSaveVariable = (key, value) => dispatch(
    triggerSetAndSaveVariableSaga({ key, value }),
  );

  const setPublicBreadcrumbs = (breadcrumbsIn, index) => dispatch(
    triggerSetPublicBreadcrumbsSaga({ breadcrumbs: breadcrumbsIn, index }),
  );
  const setPrivateBreadcrumbs = (breadcrumbsIn, index) => dispatch(
    triggerSetPrivateBreadcrumbsSaga({ breadcrumbs: breadcrumbsIn, index }),
  );
  const publicBreadcrumbs = useSelector((state) => state.undo.present.public.breadcrumbs);
  const privateBreadcrumbs = useSelector((state) => state.undo.present.private.breadcrumbs);

  const items = useSelector(selectMenuListItemsArray);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log('handleClose()');
    setAnchorEl(null);
  };

  const handleExit = async () => {
    console.log('handleExit()', window.location.pathname);
    await setAndSaveVariable('SCORE', '0');
    await setPrivateBreadcrumbs(privateBreadcrumbs.slice(0, 2));
    await setPublicBreadcrumbs(publicBreadcrumbs.slice(0, 2));
  };
  return (
    <div>
      <Button
        aria-controls='customized-menu'
        aria-haspopup='true'
        variant='contained'
        color='primary'
        onClick={handleClick}
      >
        <MenuIcon />
      </Button>
      <Menu
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted={true}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {items && items.length && items[0] && items.map((i) => (
          <MenuItem key={i?.id} onClick={handleClose}>
            <ListItemText
              onClick={() => {
                goTo(i.Name.value);
              }}
              primary={i?.Name?.value}
            />
          </MenuItem>
        ))}
        <MenuItem key='Exit' onClick={handleExit}>
          <Link to='/'>Exit</Link>
        </MenuItem>
      </Menu>
    </div>
  );
}

AppMenu.propTypes = {
  goTo: PropTypes.func.isRequired,
};

export default AppMenu;
